import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import styles from './searchItem.module.scss'
import { getCurrentTextLanguage } from '../../helpers/helpers'
import { RootState } from '../../redux/store'

interface SearchItemProps {
  nameObj: any
  language?: string
  id: string
  type: string
}

const SearchItem: React.FC<SearchItemProps> = ({
  nameObj,
  language,
  id,
  type,
}: SearchItemProps) => {
  const [name, setName] = useState<string>('')

  useEffect(() => {
    setName(getCurrentTextLanguage(nameObj))
  }, [])

  useEffect(() => {
    setName(getCurrentTextLanguage(nameObj))
  }, [language])

  return (
    <NavLink
      to={id ? `/${type}/${id}/${nameObj.eng}` : '#'}
      className={styles.container}
    >
      {name}
    </NavLink>
  )
}

let mapStateToProps = (state: RootState) => {
  return {
    language: state.main.language,
  }
}

export default connect(mapStateToProps, {})(SearchItem)
